
import { Injectable } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';

@Injectable()
export class DateFormatterService extends NgbDateParserFormatter {
  format(date: NgbDateStruct | null): string {
    if (!date) return '';
    return moment({ year: date.year, month: date.month - 1, day: date.day }).format('MM/DD/YYYY');
  }

  parse(value: string): NgbDateStruct | null {
    if (!value) return null;
    const m = moment(value, 'MM/DD/YYYY');
    if (!m.isValid()) return null;
    return { year: m.year(), month: m.month() + 1, day: m.date() };
  }
}
